import { Tab } from '../../../../../views/active-orders';

export default {
  title: 'Ravintolan kojelauta',
  tabs: {
    [Tab.OngoingOrders]: 'Valmista nyt',
    [Tab.FutureOrders]: 'Tulevat',
    [Tab.CompleteOrders]: 'Valmiit',
  },
  buttons: {
    order_history: 'Tilaushistoria',
  },
  feedback: {
    future_orders_alert: '⚠️ Älä valmista vielä – ilmoitamme, kun voit aloittaa.',
  },
};
